<template>
    <ion-toolbar>
      
    </ion-toolbar>

    <div class="main_wrapper ion-padding">
        <div class="welcome_text">
            <span>Welcome to</span>
            <img src="@/assets/img/logo_text.svg" alt="" class="logo_text">
            <div class="select_type_text">
                <span>Before you start exploring, we'd like to learn a bit more about you to tailor your experience and ensure you get the most out of the system.</span>
            </div>
        </div>

        <div class="buttons_wrapper">
            <el-button type="transparent" class="bg-white" @click="goNext()">
                Continue
            </el-button>
           
        </div>
    </div>
</template>


<script>
    import {
        onMounted,
        onUnmounted,
    } from 'vue';

    import {
        IonToolbar,
    } from '@ionic/vue';

    import {
        useRouter,
    } from 'vue-router'

    export default {
        components: {
            IonToolbar
        },
        setup() {
            const $router = useRouter()

           
            const goNext = () => {
                $router.push({
                    name: 'auth_internal_software_experience',
                })
            }

            onMounted(() => {
                $('body').addClass('background_blue');
            });

            onUnmounted(() => {
                $('body').removeClass('background_blue');
            });
            return {
                goNext,
            }
        }
    }
</script>